// src/pages/page.js (Landing Page component)
import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faSearch, 
  faChartLine, 
  faEdit, 
  faRocket,
  faCheckCircle,
  faUsers,
  faShieldAlt,
  faLightbulb
} from "@fortawesome/free-solid-svg-icons";

const LandingPage = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '80px 20px',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ 
            fontSize: '3.5rem', 
            fontWeight: 'bold', 
            marginBottom: '20px',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}>
            BuddyX
          </h1>
          <p style={{ 
            fontSize: '1.5rem', 
            marginBottom: '40px',
            opacity: 0.9
          }}>
            Your AI-Powered SEO and Content Optimization Platform
          </p>
          <p style={{ 
            fontSize: '1.1rem', 
            marginBottom: '50px',
            opacity: 0.8,
            maxWidth: '800px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            Transform your digital presence with advanced keyword research, ranking analysis, 
            and AI-generated SEO content that drives real results.
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/home" style={{
              backgroundColor: '#28a745',
              color: 'white',
              padding: '15px 30px',
              borderRadius: '50px',
              textDecoration: 'none',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
            }}>
              <FontAwesomeIcon icon={faRocket} style={{ marginRight: '10px' }} />
              Get Started
            </Link>
            <Link to="/signIn" style={{
              backgroundColor: 'transparent',
              color: 'white',
              padding: '15px 30px',
              borderRadius: '50px',
              textDecoration: 'none',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              border: '2px solid white',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = '#667eea';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'white';
            }}>
              Sign In
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: '80px 20px', backgroundColor: 'white' }}>
        <div className="container">
          <h2 style={{ 
            textAlign: 'center', 
            fontSize: '2.5rem', 
            marginBottom: '60px',
            color: '#333'
          }}>
            Powerful Features for Modern SEO
          </h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div style={{
                textAlign: 'center',
                padding: '30px 20px',
                borderRadius: '15px',
                backgroundColor: '#f8f9fa',
                height: '100%',
                transition: 'transform 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                <FontAwesomeIcon 
                  icon={faSearch} 
                  style={{ 
                    fontSize: '3rem', 
                    color: '#667eea', 
                    marginBottom: '20px' 
                  }} 
                />
                <h3 style={{ marginBottom: '15px', color: '#333' }}>Keyword Research</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>
                  Discover high-value keywords with our advanced research tools. 
                  Get insights into search volume, competition, and ranking opportunities.
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div style={{
                textAlign: 'center',
                padding: '30px 20px',
                borderRadius: '15px',
                backgroundColor: '#f8f9fa',
                height: '100%',
                transition: 'transform 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                <FontAwesomeIcon 
                  icon={faChartLine} 
                  style={{ 
                    fontSize: '3rem', 
                    color: '#28a745', 
                    marginBottom: '20px' 
                  }} 
                />
                <h3 style={{ marginBottom: '15px', color: '#333' }}>Ranking Analysis</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>
                  Track your website's performance with comprehensive ranking analysis. 
                  Monitor SERP positions and competitor insights.
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div style={{
                textAlign: 'center',
                padding: '30px 20px',
                borderRadius: '15px',
                backgroundColor: '#f8f9fa',
                height: '100%',
                transition: 'transform 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                <FontAwesomeIcon 
                  icon={faEdit} 
                  style={{ 
                    fontSize: '3rem', 
                    color: '#ffc107', 
                    marginBottom: '20px' 
                  }} 
                />
                <h3 style={{ marginBottom: '15px', color: '#333' }}>AI Content Generation</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>
                  Generate SEO-optimized content with AI assistance. 
                  Create titles, meta descriptions, and content that ranks.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section style={{ padding: '80px 20px', backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <h2 style={{ 
            textAlign: 'center', 
            fontSize: '2.5rem', 
            marginBottom: '60px',
            color: '#333'
          }}>
            Why Choose BuddyX?
          </h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
                <FontAwesomeIcon 
                  icon={faCheckCircle} 
                  style={{ 
                    fontSize: '1.5rem', 
                    color: '#28a745', 
                    marginRight: '15px',
                    marginTop: '5px'
                  }} 
                />
                <div>
                  <h4 style={{ marginBottom: '10px', color: '#333' }}>AI-Powered Insights</h4>
                  <p style={{ color: '#666', margin: 0 }}>
                    Leverage advanced AI algorithms for data-driven SEO decisions and content optimization.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
                <FontAwesomeIcon 
                  icon={faUsers} 
                  style={{ 
                    fontSize: '1.5rem', 
                    color: '#667eea', 
                    marginRight: '15px',
                    marginTop: '5px'
                  }} 
                />
                <div>
                  <h4 style={{ marginBottom: '10px', color: '#333' }}>Team Collaboration</h4>
                  <p style={{ color: '#666', margin: 0 }}>
                    Work seamlessly with your team on SEO projects and content strategies.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
                <FontAwesomeIcon 
                  icon={faShieldAlt} 
                  style={{ 
                    fontSize: '1.5rem', 
                    color: '#ffc107', 
                    marginRight: '15px',
                    marginTop: '5px'
                  }} 
                />
                <div>
                  <h4 style={{ marginBottom: '10px', color: '#333' }}>Secure & Reliable</h4>
                  <p style={{ color: '#666', margin: 0 }}>
                    Enterprise-grade security with 99.9% uptime and reliable data processing.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
                <FontAwesomeIcon 
                  icon={faLightbulb} 
                  style={{ 
                    fontSize: '1.5rem', 
                    color: '#dc3545', 
                    marginRight: '15px',
                    marginTop: '5px'
                  }} 
                />
                <div>
                  <h4 style={{ marginBottom: '10px', color: '#333' }}>Smart Recommendations</h4>
                  <p style={{ color: '#666', margin: 0 }}>
                    Get intelligent suggestions for improving your SEO strategy and content performance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
        color: 'white',
        padding: '80px 20px',
        textAlign: 'center'
      }}>
        <div className="container">
          <h2 style={{ 
            fontSize: '2.5rem', 
            marginBottom: '20px',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}>
            Ready to Boost Your SEO?
          </h2>
          <p style={{ 
            fontSize: '1.2rem', 
            marginBottom: '40px',
            opacity: 0.9
          }}>
            Join thousands of businesses that trust BuddyX for their SEO success.
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/home" style={{
              backgroundColor: 'white',
              color: '#28a745',
              padding: '15px 30px',
              borderRadius: '50px',
              textDecoration: 'none',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
            }}>
              <FontAwesomeIcon icon={faRocket} style={{ marginRight: '10px' }} />
              Start Free Trial
            </Link>
            <Link to="/signIn" style={{
              backgroundColor: 'transparent',
              color: 'white',
              padding: '15px 30px',
              borderRadius: '50px',
              textDecoration: 'none',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              border: '2px solid white',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = '#28a745';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'white';
            }}>
              Sign In Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
